import React from "react";
import "./Blog.css";
import { useNavigate } from "react-router-dom";

const Blog = () => {

  const navigate = useNavigate();

  return (
    <div className="blog-coming-container">
      <div className="blog-coming-box">

        <h1 className="blog-title">Blog</h1>

        <h2>Coming Soon 🚧</h2>

        <p>
          Plenary Holidays blog section is under development.
          Soon you will get travel guides, yatra updates,
          and spiritual articles here.
        </p>

        <button onClick={() => navigate("/")} className="back-home-btn">
          Back To Home
        </button>

      </div>
    </div>
  );
};

export default Blog;